/* eslint-disable react/no-multi-comp */

import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, intlShape, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import cx from 'classnames';
import randomstring from 'uuid/v4';

import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import Dialog from '@material-ui/core/Dialog';
import Divider from '@material-ui/core/Divider';
import TextField from '@material-ui/core/TextField';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import Checkbox from '@material-ui/core/Checkbox';

import Tree from '../../../tree/Index';

import DayMonth from '../../../inputs/DayMonth';
import { BlueCloseIcon, BlueTickIcon } from '../../../../images/icons/WrapSvg';

// eslint-disable-next-line
import style from './_styles.css';

const ds = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];
const nums = [1, 2, 3, 4, 5];

const parseWeeks = (arr) => {
    const result = arr.reduce((a, e) => {
        if (!isNumeric(e) && e.length === 1) {
            a.push({ id: e, weeks: [...nums] });
        } else if (!isNumeric(e) && e.length === 2) {
            const index = a.map((x) => x.id).indexOf(e.substr(0, 1));
            if (index === -1) {
                a.push({ id: e.substr(0, 1), weeks: [parseInt(e.substr(1, 1), 10)] });
            } else {
                const element = a.find((x) => x.id === e.substr(0, 1));
                element.weeks.push(parseInt(e.substr(1, 1), 10));
            }
        }
        return a;
    }, []);
    return result;
};

const parseMonth = (arr) => {
    const result = arr.reduce((a, e) => {
        if (isNumeric(e)) {
            a.push(parseInt(e, 10));
        }
        return a;
    }, []);
    return result;
};

const parseDay = (arr) => {
    const result = arr.find((e) => !isNumeric(e) && e.indexOf('/') > 0);
    if (result) return result;
    else return '';
};

const isNumeric = (n) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
};

const flatNodes = (node) => {
    let result = [node];
    if (node.children) {
        node.children.forEach((c) => (result = result.concat(flatNodes(c))));
    }
    return result;
};

const reviewComplete = (node, arr) => {
    const toReview = flatNodes(node);
    let result = true;

    if (toReview && toReview.length > 0) {
        const index = arr.map((i) => i.id);
        toReview.forEach((r) => {
            result = result && index.indexOf(r.id) >= 0;
        });
    }

    return result;
};

const highNode = (arr) => {
    const result = [];
    [...arr]
        .sort((a, b) => (a.path > b.path ? 1 : -1))
        .forEach((c) => {
            if (arr.map((i) => parseInt(i.id, 10)).indexOf(parseInt(c.id, 10)) >= 0) {
                const nodes = flatNodes(c);
                nodes.splice(0, 1);
                if (nodes && nodes.length > 0) {
                    nodes.forEach((n) => {
                        const toRemoveIndex = arr.map((i) => i.id).indexOf(n.id);
                        if (toRemoveIndex >= 0) arr.splice(toRemoveIndex, 1);
                    });
                }
                result.push(c);
            }
        });
    return result;
};

class TimeDialog extends React.Component {
    state = {
        scroll: 'body',
        time: '',
        times: this.props.value !== undefined ? this.props.value.times : [],
        week: parseWeeks(this.props.value !== undefined ? this.props.value.week : []),
        month: parseMonth(this.props.value !== undefined ? this.props.value.week : []),
        day: parseDay(this.props.value !== undefined ? this.props.value.week : []),
        active: this.props.value !== undefined ? flatNodes(this.props.value.node) : [],
        data: this.props.info.security.hierarchies,
        day_month:
            parseMonth(this.props.value !== undefined ? this.props.value.week : []).length > 0,
        day_week:
            parseWeeks(this.props.value !== undefined ? this.props.value.week : []).length > 0,
        day_year: parseDay(this.props.value !== undefined ? this.props.value.week : [])
            ? true
            : false,
    };

    handleClose = () => {
        this.props.onClose();
    };

    handleSummit = () => {
        const { times, week, month, active, day, day_week, day_month, day_year } = this.state;
        let result = [];

        if (day_week) {
            result = week.reduce((a, d) => {
                if (d.weeks.length === nums.length) a.push(d.id);
                else if (d.weeks.length > 0) {
                    a = a.concat(
                        d.weeks.map((n) => {
                            return d.id + n;
                        }),
                    );
                }
                return a;
            }, []);
        }
        if (day_month) {
            result = result.concat(month);
        }

        if (
            day_year &&
            day &&
            day.length === 5 &&
            parseInt(day.split('/')[0], 10) < 32 &&
            parseInt(day.split('/')[0], 10) > 0 &&
            parseInt(day.split('/')[1], 10) < 13 &&
            parseInt(day.split('/')[1], 10) > 0
        ) {
            result.push(day);
        }

        if (result.length === 0) {
            result = ds;
        }

        this.props.onClose(times, result, highNode(active));
    };

    handleChange = (name) => (event) => {
        this.setState({
            [name]: event.target.value,
        });
    };

    handleChecked = (name) => (event) => {
        this.setState({ [name]: event.target.checked });
    };

    handleChangeDay = (value) => {
        this.setState({
            day: value,
        });
    };

    handleAdd = (event) => {
        if (this.state.time && this.state.time.trim()) {
            const value = this.state.time.trim();
            const arr = [...this.state.times];
            if (arr.indexOf(value) < 0) {
                arr.push(value);
                this.setState({ times: arr, time: '' });
            }
        }
    };

    handleDelete = (data) => () => {
        const arr = [...this.state.times];
        const toDelete = arr.indexOf(data);
        arr.splice(toDelete, 1);
        this.setState({ times: arr });
    };

    handleClickWeek = (time) => (event) => {
        var arr = this.state.week;
        var index = this.state.week.map((d) => d.id).indexOf(time);

        if (index === undefined || index < 0) {
            arr = this.state.week.slice();
            arr.push({ id: time, weeks: [...nums] });
        } else {
            arr.splice(index, 1);
        }

        this.setState({
            week: arr,
        });
    };

    handleClickDayWeek = (id, day) => (event) => {
        let arr = this.state.week.slice();
        const value = arr.find((d) => d.id === id);
        const index = arr.map((d) => d.id).indexOf(id);
        if (index === undefined || index < 0) {
            arr.push({ id: id, weeks: [day] });
        } else {
            const i = value.weeks.indexOf(day);
            if (i === undefined || i < 0) {
                value.weeks.push(day);
            } else {
                value.weeks.splice(i, 1);
            }
            arr.splice(index, 1);
            if (value.weeks.length > 0) {
                arr.push(value);
            }
        }
        this.setState({
            week: arr,
        });
    };

    handleClickAllWeek = (all) => (event) => {
        const weeks = all
            ? ds.map((d) => {
                  return { id: d, weeks: [...nums] };
              })
            : [];
        this.setState({
            week: weeks,
        });
    };

    handleClickMonth = (day) => (event) => {
        var arr = this.state.month;
        var index = this.state.month.indexOf(day);

        if (index === undefined || index < 0) {
            arr = this.state.month.slice();
            arr.push(day);
        } else {
            arr.splice(index, 1);
        }

        this.setState({
            month: arr,
        });
    };

    isCorrect = () => {
        const { times, active, day, day_year } = this.state;
        return (
            (!this.props.showTime || times.length > 0) &&
            active &&
            active.length > 0 &&
            (!day_year ||
                (day &&
                    day_year &&
                    day.length === 5 &&
                    parseInt(day.split('/')[0], 10) < 32 &&
                    parseInt(day.split('/')[0], 10) > 0 &&
                    parseInt(day.split('/')[1], 10) < 13 &&
                    parseInt(day.split('/')[1], 10) > 0))
        );
    };

    renderNode = (node) => {
        return (
            <span
                className={cx(
                    'barlow_regular_message margin_left_12 ',
                    {
                        c_bluish:
                            node &&
                            this.state.active &&
                            this.state.active.some(
                                (n) => parseInt(n.id, 10) === parseInt(node.id, 10),
                            ),
                    },
                    {
                        c_lipstick: !this.isNodeEnabled(node),
                    },
                )}
                onMouseDown={function(e) {
                    e.stopPropagation();
                }}
                onClick={this.onClickNode.bind(null, node)}
            >
                {node.name}
            </span>
        );
    };

    renderCollapse = (collapsed) => {
        return (
            <span
                className={cx('collapse', collapsed ? 'caret-right' : 'caret-down')}
                onMouseDown={function(e) {
                    e.stopPropagation();
                }}
                onClick={this.handleCollapse}
            />
        );
    };

    isNodeEnabled = (node) => {
        const { info } = this.props;
        const enable =
            node &&
            node.id &&
            info &&
            info.security &&
            info.security.localPermits &&
            info.security.localPermits[node.id.toString()]
                ? info.security.localPermits[node.id.toString()].some(
                      (r) => r === '20' || r === '64',
                  )
                : info && info.security && info.security.globalPermits
                ? info.security.globalPermits.some((r) => r === '20' || r === '64')
                : undefined;
        return enable;
    };

    onClickNode = (node) => {
        if (this.isNodeEnabled(node)) {
            let nodes = flatNodes(node);
            if (
                node &&
                this.state.active &&
                this.state.active.map((c) => c.id).indexOf(node.id) >= 0
            ) {
                const toRemove = nodes;
                if (toRemove && toRemove.length > 0) {
                    nodes = this.state.active;
                    toRemove.forEach((r) => {
                        const index = nodes.map((i) => i.id).indexOf(r.id);
                        if (index >= 0) {
                            nodes.splice(index, 1);
                        }
                    });
                }
            } else {
                const aux = this.state.active;
                nodes.forEach((r) => {
                    const index = aux.map((i) => i.id).indexOf(r.id);
                    if (index < 0) {
                        aux.push(r);
                    }
                });
                nodes = aux;
            }

            if (nodes && nodes.length > 0) {
                [...nodes]
                    .sort((a, b) => (a.path > b.path ? -1 : 1))
                    .forEach((n) => {
                        if (!reviewComplete(n, nodes)) {
                            const toRemoveIndex = nodes.map((i) => i.id).indexOf(n.id);
                            nodes.splice(toRemoveIndex, 1);
                        }
                    });
            }
            this.setState({
                active: nodes,
            });
        }
    };

    createTableWeek = (week) => {
        const days = [
            'form_week_day_monday',
            'form_week_day_tuesday',
            'form_week_day_wednesday',
            'form_week_day_thursday',
            'form_week_day_friday',
            'form_week_day_saturday',
            'form_week_day_sunday',
        ];
        return (
            <div className="flex_full_column barlow_semibold_label c_bluish elements_center align_center">
                <div className="box">
                    {days.map((d, i) => {
                        const value = week.find((d) => d.id === ds[i]);
                        return (
                            <div key={randomstring()} className="rowwrap">
                                <div
                                    onClick={this.handleClickWeek(ds[i])}
                                    className={
                                        'cell text_align_center hand c_white' +
                                        (value ? ' bg_bluish ' : ' bg_cool_grey')
                                    }
                                >
                                    <FormattedMessage id={d} />
                                </div>
                                {nums.map((n) => {
                                    return (
                                        <div
                                            key={randomstring()}
                                            onClick={this.handleClickDayWeek(ds[i], n)}
                                            className={
                                                'cell text_align_center' +
                                                (value && value.weeks.indexOf(n) >= 0
                                                    ? ' c_white bg_bluish_25 '
                                                    : '')
                                            }
                                        >
                                            {n}
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
                    <div key={randomstring()} className="rowwrap">
                        <div
                            onClick={this.handleClickAllWeek(true)}
                            className={
                                'cell text_align_center hand c_white' +
                                (week.length === 7 ? ' bg_bluish ' : ' bg_cool_grey')
                            }
                        >
                            <FormattedMessage id="form_week_day_all_days" />
                        </div>
                    </div>
                    <div key={randomstring()} className="rowwrap">
                        <div
                            onClick={this.handleClickAllWeek(false)}
                            className={
                                'cell text_align_center hand c_white' +
                                (week.length === 7 ? ' bg_bluish ' : ' bg_cool_grey')
                            }
                        >
                            <FormattedMessage id="form_week_day_no_days" />
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    createTableMonth = (month) => {
        let table = [];
        for (let i = 1; i <= 31; i++) {
            table.push(
                <Grid
                    item
                    xs={1}
                    key={randomstring()}
                    onClick={this.handleClickMonth(i)}
                    className={
                        'hand elements_center align_center text_align_center padding_borders ' +
                        (month.indexOf(i) >= 0 ? 'c_white bg_bluish' : '')
                    }
                >
                    <span className={'barlow_regular_small '}>{i}</span>
                </Grid>,
            );
        }
        return table;
    };

    render() {
        const { intl, onClose, open, fullScreen, showTime } = this.props;
        const { time, times, week, month, data, day } = this.state;
        console.log(data);
        return (
            <Dialog
                fullScreen={fullScreen}
                onClose={this.handleClose}
                aria-labelledby="simple-dialog-title"
                open={open}
                className="z_index_dialog_over_dialog "
                scroll={this.state.scroll}
            >
                <div className={'flex_header'}>
                    <div className={'flex_full_row padding_borders shadow'}>
                        <BlueCloseIcon
                            color="primary"
                            onClick={(e) => onClose(e)}
                            className="margin_right_18 hand"
                        />
                        <span className={'barlowsemicondensed_bold flex_full c_dark_grey_blue '}>
                            <FormattedMessage id="programming_time_title" />
                        </span>
                        {this.isCorrect() ? (
                            <BlueTickIcon
                                className="hand"
                                color="primary"
                                onClick={this.handleSummit}
                            />
                        ) : (
                            <div />
                        )}
                    </div>
                </div>
                <div className="flex_full_column padding_borders overflow_y_scroll">
                    <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_24 margin_bottom_12">
                        <FormattedMessage id="time_dialog_programming_calendar_title" />
                    </div>
                    {showTime && (
                        <div className="flex_full_row">
                            <TextField
                                id="time-picker-dialog"
                                label={intl.formatMessage({ id: 'time_field_label' })}
                                type="time"
                                fullWidth
                                className="margin_bottom_12"
                                value={time}
                                onChange={this.handleChange('time')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                inputProps={{
                                    step: 1800, //5 min
                                }}
                            />
                            <Fab
                                size="small"
                                color="secondary"
                                aria-label="add"
                                onClick={this.handleAdd}
                                className="margin_left_12"
                            >
                                <AddIcon />
                            </Fab>
                        </div>
                    )}
                    {showTime && (
                        <div className="wrap padding_top_24">
                            {times.map((data) => {
                                return (
                                    <Chip
                                        key={data}
                                        label={data}
                                        onDelete={this.handleDelete(data)}
                                        className="margin_right_12 margin_bottom_12 c_white bg_bluish"
                                    />
                                );
                            })}
                        </div>
                    )}
                    <div className="flex_full_column">
                        <div className="flex_full_row align_center padding_top_24">
                            <Checkbox
                                checked={this.state.day_week}
                                onChange={this.handleChecked('day_week')}
                                value="day_week"
                                color="primary"
                            />
                            <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                                <FormattedMessage id="time_dialog_day_week_title" />
                            </div>
                        </div>
                    </div>
                    {this.state.day_week && (
                        <div className="flex_full_row c_dark_grey_blue barlow_medium_tree_local padding_top_24 margin_bottom_12">
                            {this.createTableWeek(week)}
                        </div>
                    )}
                    <Divider className={'margin_top_18 margin_bottom_12'} />
                    <div className="flex_full_row align_center padding_top_24">
                        <Checkbox
                            checked={this.state.day_month}
                            onChange={this.handleChecked('day_month')}
                            value="day_month"
                            color="primary"
                        />
                        <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                            <FormattedMessage id="form_field_add_date_month" />
                        </div>
                    </div>
                    {this.state.day_month && (
                        <div className="flex_full_row c_bluish barlow_semibold_label padding_top_24 elements_center">
                            <Grid container className="elements_center">
                                {this.createTableMonth(month)}
                            </Grid>
                        </div>
                    )}
                    <Divider className={'margin_top_18 margin_bottom_12'} />
                    <div className="flex_full_row align_center padding_top_24">
                        <Checkbox
                            checked={this.state.day_year}
                            onChange={this.handleChecked('day_year')}
                            value="day_year"
                            color="primary"
                        />
                        <div className="flex_full_row c_dark_grey_blue barlow_medium_subtitle">
                            <FormattedMessage id="form_field_add_date_label" />
                        </div>
                    </div>
                    {this.state.day_year && (
                        <div className="flex_full_row c_bluish barlow_semibold_label elements_center">
                            <DayMonth value={day} handleChange={this.handleChangeDay} />
                        </div>
                    )}
                    <Divider className={'margin_top_18 margin_bottom_12'} />
                    <div className="flex_full_row c_dark_grey_blue barlow_semibold padding_top_24 margin_bottom_12">
                        <FormattedMessage id="time_dialog_locals_title" />
                    </div>
                    <div className="flex_full_row padding_borders margin_bottom_12">
                        <Tree
                            paddingLeft={40} // left padding for children nodes in pixels
                            tree={data}
                            renderNode={this.renderNode} // renderNode(node) return react element
                            renderCollapse={this.renderCollapse}
                            isNodeCollapsed={this.isNodeCollapsed}
                        />
                    </div>
                </div>
            </Dialog>
        );
    }
}

TimeDialog.propTypes = {
    intl: intlShape.isRequired,
    fullScreen: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => {
    return {
        info: state.info,
    };
};

TimeDialog = connect(
    mapStateToProps,
    null,
)(TimeDialog);

TimeDialog = injectIntl(TimeDialog);

export default withMobileDialog()(TimeDialog);



// WEBPACK FOOTER //
// ./src/components/complex/manage/checks/TimeDialog.js